import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from '../../environments/environment';
declare var gtag: (command: string, ...params: any[]) => void;

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  constructor(private router: Router) {}

  public event(eventName: string, params: unknown) {
    gtag('event', eventName, params);
  }

  public init() {
    this.listenForRouteChanges();

    try {
      const gtmScript1 = document.createElement('script');
      gtmScript1.innerHTML =
        `dataLayer = [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '` +
        environment.googleTagManagerKey +
        `');`;
      document.head.appendChild(gtmScript1);

      const gtmScript2 = document.createElement('script');
      gtmScript2.innerHTML = `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${environment.googleTagManagerKey}');`;

      document.head.appendChild(gtmScript2);
    } catch (ex) {
      console.error('Error appending google analytics');
      console.error(ex);
    }
  }

  private listenForRouteChanges() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        gtag('config', environment.googleTagManagerKey, {
          page_path: event.urlAfterRedirects,
        });
      }
    });
  }
}
